import { Mapper } from "../../../../base/utils/mapper";
import { ConsentModel } from "../../../../domain/models/configuration/consent.model";
import { ConsentEntity } from "../entities/consent.entity";

export class ConsentImplementationRepositoryMapper extends Mapper<ConsentEntity, ConsentModel> {
    mapFrom(param: ConsentEntity): ConsentModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: ConsentModel): ConsentEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}